import React from 'react';
import { useDispatch } from 'react-redux';
import GerberFile from 'pu-react/components/GerberFileFC';
import { processFile as processZipFile } from 'product_tabs/tab_parts/slice/process_file';

const tooltip = `For Fabrication please include in the Zip File:
- Gerber files.
- Fabrication Notes (if available)
- Fabrication Drawings (if available)

For Assembly please include in the Zip File:

- BOM
- XY Data
- Assembly Drawings (If available)
- Assembly Notes (if available)`;

// const fabRequireFile = (step, destroy, lineItemId) => {
//   // if (step === START_QUOTE) return true;
//   //
//   // if (step !== PRICE_SELECTED) return false;
//   //
//   // if (destroy) return false;
//   //
//   // if (lineItemId) return false;

//   if (!destroy && lineItemId) return false;

//   return true;
// }

// const stencilRequireFile = (stencils) => {
//   if (stencils.length === 0) return false;

//   const anyNew = stencils.find((stencil) => !stencil.line_item_id)

//   if (anyNew) return true;

//   return false;
// }

const ZipFile = (props) => {
  const dispatch = useDispatch();
  const {
    label,
    text,
    parameters,
    onChangeParameter,
    validator,
    fabRequireFile,
    stencilRequireFile,
  } = props;

  const processFile = (file) => {
    dispatch(processZipFile(file))
  }

  const requireFile = fabRequireFile() || stencilRequireFile();

  return (
    <GerberFile
      parameters={parameters}
      onChangeParameter={onChangeParameter}
      processFile={processFile}
      label={label}
      text={text}
      tooltip={tooltip}
      errorMessage={requireFile && validator.message('Zip file', parameters.filename, 'required')} />
  )
};

export default ZipFile;
